import moment from "moment"
import { Avatar, Button, Chip, Typography } from "../../../../components/common"
import { LockIcon, WhiteBreifCaseIcon } from "../../../../theme/icons2"
import { generateBGColorClassName } from "../../../../utils/randomColor"

export const CustomRaisedByComponent = (params) => {
    const { rowIndex, data } = params
    return (<div className="flex gap-2 h-full items-center ">
        <div className="flex items-center">
            <Avatar type="text" alt={data?.requester?.name} className={`${generateBGColorClassName(rowIndex)}`} />
        </div>
        <div className="flex flex-col  truncate">
            <Typography variant="base" className="truncate text-left font-semibold capitalize" text={data?.requester?.name} />
            <Typography variant="sm" className="truncate text-left" text={data?.requester?.email} />
        </div>
    </div>)
}

export const CustomClientNameComponent = (params) => {
    const { rowIndex, data } = params
    return (<div className="flex gap-2  h-full items-center ">
        <div className={`flex items-center p-3 rounded-full ${generateBGColorClassName(rowIndex + 1)}`}>
            <WhiteBreifCaseIcon />
        </div>
        <div className="flex flex-col max-w-sm">
            <Typography variant="base" className="line-clamp-2 whitespace-break-spacestext-left" text={data?.client?.name} />
            <Typography variant="sm" className="truncate text-left" text={data?.custom_fields?.cf_domain_name949839} />
        </div>
    </div>)
}

export const CustomIDComponent = (params) => {
    const { data } = params
    const { id, haveAccess = false } = data;
    return (
        <div className="flex gap-2  h-full items-center ">
            {haveAccess ? <Typography variant="base" className="truncate text-left" text={`#${id}`} /> :
                <div className="flex justify-start items-center gap-2 w-full cursor-not-allowed">
                    <LockIcon mode={'inactive'} />
                    <Typography variant="sm" className="truncate text-left text-secondary-400" text={`No access to view This ticket`} />
                </div>
            }
        </div>
    )
}

export const CustomStatusComponent = (params) => {
    const { data } = params;

    const statusVariables = {
        '2': <Chip variant="chip-deep-purple" text="Open" />,
        '3': <Chip variant="chip-orange" text="Pending" />,
        '5': <Chip variant="chip-success" text="Closed" />,
        '4': <Chip variant="chip-teal" text="Resolved" />,
        '8': <Chip variant="chip-orange" text="On Hold" />
    }
    return (<div className="flex flex-col h-full justify-center w-fit">
        {statusVariables[String(data?.status)]}
    </div>)
}

export const ActionComponent = (params) => {
    const { handleViewTicket = () => null, data = {}, rowIndex = 0 } = params || { handleViewTicket: () => null, data: {} };

    return (<div className="flex gap-2 justify-center  h-full items-center ml-auto">
        <Button variant="tertiary" onClick={() => handleViewTicket({ ...data, rowIndex })} className="h-fit" text="View Details" />
    </div>)
}

export const CustomDateComponent = (params) => {
    const { data } = params;
    return data?.created_at ? moment(data?.created_at)?.format('DD MMM HH:mm A') : ''
}